import React from 'react';
import { Col, Row, Text } from 'components';
import { FontAwesome5 } from '@expo/vector-icons';
import { StyleSheet } from 'react-native';

const SUCCESS = '#1FA463';

interface KPICardProps {
  value: string;
  label: string;
  color: string;
  progress?: number;
  trend?: {
    direction: 'up' | 'down';
    text: string;
  };
}

const KPICard: React.FC<KPICardProps> = ({ value, label, color, progress, trend }) => {
  return (
    <Col style={styles.kpiCard} flex1>
      <Text fontSize={36} bold style={{ color }} marginBottom={4}>
        {value}
      </Text>
      <Text fontSize={12} semiBold color="#4B5563" style={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
        {label}
      </Text>
      {progress !== undefined && (
        <Col style={styles.progressBar} marginTop={12}>
          <Col style={[styles.progressFill, { width: `${progress}%`, backgroundColor: color }]} />
        </Col>
      )}
      {trend && (
        <Row alignItems="center" marginTop={12}>
          <FontAwesome5
            name={trend.direction === 'down' ? 'arrow-down' : 'arrow-up'}
            size={12}
            color={SUCCESS}
            style={{ marginRight: 4 }}
          />
          <Text fontSize={12} style={{ color: SUCCESS }}>
            {trend.text}
          </Text>
        </Row>
      )}
    </Col>
  );
};

const styles = StyleSheet.create({
  kpiCard: {
    backgroundColor: 'white',
    padding: 24,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 1,
  },
  progressBar: {
    width: '100%',
    height: 8,
    backgroundColor: '#E5E7EB',
    borderRadius: 4,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: 4,
  },
});

export default KPICard;

